// extracted by mini-css-extract-plugin
module.exports = {"close-task":"components-Tasks-OptionalTask-Close__close-task--1D8cd"};